import styled, { css } from 'styled-components';
import { Text } from 'components';

export const TimeBarStyled = styled.div`
  position: relative;
  ${(props) =>
    props.isTimeshift &&
    css`
      cursor: pointer;
    `};
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledSlashText = styled(Text)`
  && {
    position: relative;
    display: block;
    margin-right: 2px;
    margin-left: 2px;
    color: rgba(255, 255, 255, 0.5);
    white-space: pre;
  }
`;

export const StyledText = styled(Text)`
  && {
    display: block;
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const StyledAirIcon = styled.div`
  position: relative;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ff3333;
  margin-right: 3px;
  margin-bottom: 2px;
  ${(props) =>
    props.isTimeshift &&
    css`
      opacity: 0.5;
    `};
`;
